export class DropdownOption {
    value: number | string;
    display: string;

    constructor(init?: Partial<DropdownOption>) {
        Object.assign(this, init);
    }
}
